import { Observable, throwError as observableThrowError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config, ServiceURLPathConfig } from '../models';
import { sprintf } from '../utils/string/string-format';
import { ConfigService } from './config.service';

export interface HttpOptions {
	headers: HttpHeaders;
	params: HttpParams;
	body: {};
}

@Injectable({providedIn: 'root'})
export class BaseJsonService {
	private readonly hostURL: string;
	public config: Config;

	readonly services: ServiceURLPathConfig;

	protected options: HttpOptions = {
		// Authorization Header is added via the BearerInterceptor -> see AppModule
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		}),
		params: new HttpParams(),
		body: {}
	};

	constructor(protected http: HttpClient,
				protected configService: ConfigService) {
		this.config = this.configService.getConfig();
		this.hostURL = this.config.backend.hostURL;
		this.services = this.config.backend.servicePaths;
	}

	protected static handleError(error: HttpErrorResponse): Observable<never> {
		return observableThrowError(error);
	}

	protected generateUrl(service: string, format: string, ...params: any[]): string {
		const result = sprintf(format, ...params);
		if (result.error) {
			return '';
		}
		return this.hostURL + service + result.replaced;
	}

}
